import React from 'react';

import { ProductCardRating } from 'components/reviews/product-card-rating';
import { useCardContext } from './card-context';

/** Grid-card rating row (stars + review count). Flag-gating lives in ProductCardRating. */
export function CardRating(): JSX.Element | null {
  const { avgRating, reviewCount } = useCardContext();

  return <ProductCardRating avgRating={avgRating} reviewCount={reviewCount} />;
}
